<template>
    <div>
        <!-- 1 line -->
        <div>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE`)" class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE`) }}
            </span>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.Business Registration No`)" class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Business Registration No`) }}
            </span>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.CEO`)" class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.CEO`) }}
            </span>
            <a
                class="mr-1"
                v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.Privacy Notice`)"
                :href="`${VUE_APP_AUTH_CENTER_URL}/privacy?locale=${$i18n.locale}&theme=${skin}`"
                target="_blank"
                style="vertical-align:text-bottom"
            >
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Privacy Notice`) }}
            </a>
            <a
                v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.CCTV Notice`)"
                href="https://privacy.megazone.com/production/mzc/cctv/index.html"
                target="_blank"
                style="vertical-align:text-bottom"
            >
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.CCTV Notice`) }}
            </a>
        </div>
        <!-- 2 line -->
        <div>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE B/D, 46, Nonhyeon-ro 85-gil, Gangnam-gu, Seoul, South Korea`)" class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE B/D, 46, Nonhyeon-ro 85-gil, Gangnam-gu, Seoul, South Korea`) }}
            </span>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.Contact Call`)" class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Call`) }}
            </span>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.Contact Email`)">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Email`) }}
            </span>
        </div>
        <!-- 3 line -->
        <div>
            <span v-if="$t(`org.footer.${VUE_APP_NAMESPACE}.Copyright`)" style="font-style:italic">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Copyright`) }}
            </span>
        </div>
    </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
export default {
    setup (props, context) {
        const VUE_APP_AUTH_CENTER_URL = process.env.VUE_APP_AUTH_CENTER_URL
        const VUE_APP_NAMESPACE = process.env.VUE_APP_NAMESPACE
        const { skin } = useAppConfig()
        return {
            VUE_APP_AUTH_CENTER_URL,
            VUE_APP_NAMESPACE,
            skin
        }
    }
}
</script>
